// hyphens are allowed.
export var rifficonList = ['balloon', 'bus', 'camera', 'dinosaur', 'mountains', 'plane', 'postcards', 'searching', 'wayfinding'];
export var rifficonStyles = ['outline', 'fill', 'outline-white'];